export const EMOJIS = {
  thumbsup: '👍',
  thumbsdown: '👎',
  love: '😻',
};
